var $fullTeam = $('.show-full-team');
$fullTeam.find('a').click(function(e) {
    e.preventDefault();

    $fullTeam.hide();
    $fullTeam.parents('.team').find('.person').removeClass('hide');
});

